// export { default as Storage } from '../Storage';
import { encode } from 'base-64';
import stringify from 'json-stable-stringify';
import numeral from 'numeral';

import i18n from '../I18n';
import { QRCODE_SHOW_RAW_MEMBERSHIP_ID } from './Config';
import { checkLanguages } from './LanguageCheckUtil';
import { inMiniProgram } from './WeChatUtil';

export const delay = (time) =>
  new Promise((resolve) => setTimeout(resolve, time));

export const camelCase = (value) =>
  value.replace(/_([a-z])/g, (g) => g[1].toUpperCase());

// export const createAction = (type) => (payload) => ({ type, payload });

const tokenRequiredAction = [
  'activityLogs/fetchUserActivityLogs',
  'activityLogs/uerActivityLogsLoadMore',
  'activityLogs/userActivityLogDetail',
  'buyCoupon/buyCoupon',
  'campaignDetail/getCampaignDetail',
  'campaignDetail/getCampaignBlackout',
  'campaignDetail/getCampaignDetailAndGoRedeemPage',
  'campaignDetail/verifyQrCode',
  'campaignDetail/verifyGPS',
  'campaignDetail/getTicketCampaignAdditionalData',
  'campaignDetail/participateTicketCampaign',
  'campaignDetail/getRegisterInfo',
  'campaignList/homeFeatureListRefresh',
  'campaignList/homeFeatureListLoadMore',
  'campaignList/homeBannnerRefresh',
  'campaignList/homeOnlyForYouListRefresh',
  'inboxMessages/refreshMessages',
  'inboxMessages/messageLoadMore',
  'inboxMessages/getMessageDetail',
  'inboxMessages/markMessageRead',
  'levels/fetchLevelRules',
  'levels/fetchLevelRetainTips',
  'levels/fetchLevelBenefits',
  'levels/fetchLevelConfig',
  'myCoupon/refreshMyCoupon',
  'myCoupon/loadMoreCoupon',
  'myCoupon/prepareDetailData',
  'myCoupon/getCouponApplicableStores',
  'myCoupon/convertVirtualToReal',
  'myCoupon/useCoupon',
  'offerContainer/getOfferTabData',
  'offerList/loadOfferList',
  'offerList/offerListLoadMore',
  'store/getStoreCategories',
  'store/getCampaignStores',
  'transaction/refreshRewardClaimList',
  'transaction/loadMoreRewardClaimList',
  'transaction/deleteRewardClaim',
  'transaction/createRewardClaim',
  'transaction/uploadFile',
  'transaction/refreshTransactionHistory',
  'transaction/loadMoreTransactionHistory',
  'transaction/getTransactionDetail',
  'unsubscribe/getCustomerSubscribeEmailDetail',
  'unsubscribe/updateCustomerSubscribeEmail',
  'userInfoTemp/updateUserDirectMarketing',
  'userInfoTemp/updateUserInfoOneField',
  'userInfoTemp/requireOTPForUpdateLoginMethod',
  'userInfoTemp/verifyOTPAndUpdateLoginMethod',
  'userInfoTemp/updateCustomerAdditionalField',
  'users/resetPassword',
  'users/updateUserInfo',
  'users/fetchUserInfo',
  'users/deleteUserAccount',
  'users/fetchPointAccount',
  'users/fetchBalance',
  'users/fetchRewardStatus',
  'users/shopifyCreatePointToCash',
  'users/createPointToCash',
  'users/cancelPointToCash',
  'users/refreshPointToCash',
  'users/fetchGiftCardInfo',
  'users/redeemGiftCard',
];
export const createAction = (type) => (payload) => {
  if (
    tokenRequiredAction.includes(type) &&
    !((payload || {}).fromRefresh || false)
  ) {
    console.log('catch refresh token');
    const newPayload = payload || {};
    newPayload.action = type;
    console.log('catch refresh token: ', newPayload);
    return { type: 'users/refreshTokenIfNeed', payload: newPayload };
  }
  return { type, payload };
};

export const nFormatter = (num, digits) => {
  const si = {
    1: '',
    2: 'K',
    3: 'M',
    4: 'G',
    5: 'T',
    6: 'P',
    7: 'E',
  };

  // const numList = num.split(',');
  const demicalNum = num.split('.')[1].replace(/(0+)\b/gi, '');
  const numList = num.split('.')[0].split(',');

  let formatdNum;
  if (numList.length === 2 && numList[0].length === 1) {
    formatdNum = demicalNum ? num.replace(/0+?$/gi, '') : num.split('.')[0];
  } else {
    formatdNum = `${numList[0]}.${numList.slice(1).join('')}`;
    if (demicalNum) {
      formatdNum += demicalNum;
    } else {
      formatdNum = formatdNum.replace(/(0+)\b/gi, '');
    }
  }
  formatdNum = formatdNum.replace(/[.]$/gi, '');
  if (digits) {
    formatdNum = Math.floor(formatdNum * 100) / Math.pow(10, digits);
  }
  return formatdNum + si[numList.length];
};

export const numberFormatter = (num) => {
  if (num >= 1000000000) {
    return `${Math.floor(num / 1000000000)
      .toString()
      .replace(/\.0$/, '')}G`;
  }
  if (num >= 1000000) {
    return `${Math.floor(num / 1000000)
      .toString()
      .replace(/\.0$/, '')}M`;
  }
  if (num >= 10000) {
    return `${Math.floor(num / 1000)
      .toString()
      .replace(/\.0$/, '')}K`;
  }
  if (num >= 1000) {
    return Math.floor(num)
      .toString()
      .replace(/^(.{1})/, '$1,');
  }
  return num;
};

const EN_NAME_CHECKER = /[!a-zA-Z]+/;
export const getDisplayName = ({ nickname, firstName, lastName }) => {
  if (nickname !== undefined && nickname !== null && nickname !== '') {
    return nickname;
  }
  if (!firstName && !lastName) {
    return i18n.t("home_guest")
  }
  if (EN_NAME_CHECKER.test(firstName)) {
    return `${firstName}`;
  }
  return `${lastName} ${firstName}`;
};

export const getTranslationData = (data, language = null) => {
  let currentLanguage = language;
  if (!language) {
    currentLanguage = i18n.language;
  }
  let baseData = data;

  (data?.translations || []).forEach((item, index) => {
    const translation = item;
    delete translation.id;
    if (currentLanguage === checkLanguages(item.language)) {
      // baseData = item;

      Object.keys(translation).forEach((key) => {
        const originalValue = baseData[key];
        const translationValue = translation[key];

        baseData[key] =
          translationValue && translationValue?.length
            ? translationValue ?? originalValue
            : originalValue;

        if (
          ['instruction_section_title', 'detail_section_title'].indexOf(key) >=
          0
        ) {
          baseData[key] = translationValue || '';
        }
      });
    }
  });

  return baseData;
};

export const getTranslationsFromApi = (data, fields = []) => {
  if (!data?.translations) {
    return {};
  };
  
  const translations = data.translations?.reduce((arr, value) => {
    const language = value.language;
    const singleTranslation = {
      language,
    };
    fields.forEach(field => {
      const fieldName = camelCase(field);
      singleTranslation[fieldName] = value[field];
    });

    return {
      ...arr,
      [language]: singleTranslation,
    }
  },
    {}
  );
  return translations || {};
};

export const getTranslationField = (data, field, language = null) => {
  const currentLanguage = language || i18n.locale;
  return data?.translations?.[currentLanguage]?.[field] || data?.[field];
};

export const enLocaleNumberFormatter = (num) => {
  if (!num) {
    return 0;
  }
  const stringNumber = num.toString();
  const commaIndex = stringNumber.indexOf('.');
  if (commaIndex === -1) {
    // return i18n.toNumber(stringNumber, { precision: 0 });
    return numeral(num).format('0,0');
  }
  return numeral(num).format('0,0.0');
  // const stringNeedFormatting = stringNumber.substring(0, commaIndex);
  // const stringEnd = stringNumber.substring(commaIndex);
  // const stringFormated = i18n.toNumber(stringNeedFormatting, { precision: 0 });
  // return `${stringFormated}${stringEnd}`;
};

export const detectIsMobile = () => {
  const isInMiniProgram = inMiniProgram()
  if (isInMiniProgram) {
    return true
  }
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  const maxTouchPoints = navigator.maxTouchPoints;
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  const matchMobileResult = toMatch.some((matchItem) => {
    return userAgent.match(matchItem);
  });
  if (matchMobileResult || (platform === 'MacIntel' && maxTouchPoints > 1)) {
    return true;
  } else {
    return false;
  }
};

export const getFileName = (url) => {
  const uri = new URL(url);
  return uri.pathname.match(/\/media\/(.*)/)[1];
};

export const arrayEqual = (arr1, arr2) => {
  if (
    arr1?.length === arr2?.length &&
    arr1.every(function (u, i) {
      return u === arr2[i];
    })
  ) {
    return true;
  } else {
    return false;
  }
};

export const generateTakeLeading = (namespace) => {
  // Source: https://github.com/dvajs/dva/issues/1872
  return (patternOrChannel, saga) => [
    function* (effects) {
      const { call, take, put } = effects;
      while (true) {
        const action = yield take(`${namespace}/${patternOrChannel}`);
        yield put({
          type: '@@DVA_LOADING/SHOW',
          payload: { namespace, actionType: patternOrChannel },
        });
        yield call(saga, action, effects);
        yield put({
          type: '@@DVA_LOADING/HIDE',
          payload: { namespace, actionType: patternOrChannel },
        });
      }
    },
    { type: 'watcher' },
  ];
};

export const getOuterSiteOrigin = (defaultOrigin = '') => {
  let outerOrigin = '';
  try {
    outerOrigin = window.parent.location.href;
  } catch (e) {
    outerOrigin = document.referrer;
  }
  return outerOrigin || defaultOrigin;
};

export const getCustomerQRCodeData = (uid, memberShipID, refreshDatetime) => {
  const codeContent = {
    uid,
    memberShipID,
    date: refreshDatetime,
  };
  // console.log('codeString', codeContent, refreshDatetime);
  const unEncodeString = stringify(codeContent);
  const encoded = encode(unEncodeString);
  const codeDataDict = {
    code: encoded,
  };
  if (!QRCODE_SHOW_RAW_MEMBERSHIP_ID) {
    codeDataDict.member_id = memberShipID;
  }
  const codeString = stringify(codeDataDict, function (a, b) {
    return b.key.localeCompare(a.key);
  });
  return codeString;
};
